/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a cron (crontab) schedule into plain English. Paste a 5-field expression and see exactly when it runs, field by field.`)
};

const es_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un horario cron (crontab) en lenguaje plano. Pega una expresión de 5 campos y ve exactamente cuándo se ejecuta, campo por campo.`)
};

const de_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie einen Cron- (Crontab-)Zeitplan in eine leicht verständliche Beschreibung. Fügen Sie einen fünfteiligen Ausdruck ein und sehen Sie Feld für Feld genau, wann er ausgeführt wird.`)
};

const nl_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een cron (crontab) schema om in eenvoudig Nederlands. Plak een 5-veld expressie en zie precies wanneer het wordt uitgevoerd, veld voor veld.`)
};

const fr_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez un horaire cron (crontab) en langage courant. Collez une expression à 5 champs et voyez exactement quand elle s'exécute, champ par champ.`)
};

const it_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma una pianificazione cron (crontab) in italiano semplice. Incolla un'espressione a 5 campi e vedi esattamente quando viene eseguita, campo per campo.`)
};

const pt_br2_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um cronograma cron (crontab) em linguagem clara. Cole uma expressão de 5 campos e veja exatamente quando ela é executada, campo a campo.`)
};

const pt_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme um agendamento cron (crontab) em português claro. Cole uma expressão de 5 campos e veja exatamente quando é executada, campo por campo.`)
};

const ja_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cronスケジュールを平文に変換します。5フィールド式をペーストして、フィールドごとに実行タイミングを確認できます。`)
};

const zh_cr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 cron（crontab）计划转换为通俗易懂的说明。粘贴一个五字段表达式，即可逐字段准确了解它的运行时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_intro", locale)
	if (locale === "en") return en_cr_intro(inputs)
	if (locale === "es") return es_cr_intro(inputs)
	if (locale === "de") return de_cr_intro(inputs)
	if (locale === "nl") return nl_cr_intro(inputs)
	if (locale === "fr") return fr_cr_intro(inputs)
	if (locale === "it") return it_cr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cr_intro(inputs)
	if (locale === "pt") return pt_cr_intro(inputs)
	if (locale === "ja") return ja_cr_intro(inputs)
	return zh_cr_intro(inputs)
};